import React from 'react';
import styles from './GroupCellRenderer.module.css';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectGridLevelLabels, selectShowGridLevelCount } from 'state/app/selectors';

const SecurityCell = ({value}) => {
  return (
    <div className={styles.root}>
      <div className={styles.securityVal}>
        {value}
      </div>
    </div>
  );
};

const LevelCell = ({data, value}) => {
  const gridLevelLabels = useSelector(selectGridLevelLabels);
  const showGridLevelCount = useSelector(selectShowGridLevelCount);

  const {securityCount, childNodesCount, levelLabel} = data;
  return (
    <div className={styles.root}>
      <div className={styles.val}>
        {value}
      </div>
      <div className={styles.subVal}>
        {gridLevelLabels && <span className={styles.level}>
          {levelLabel}
        </span>}
        {showGridLevelCount && (<span> ({childNodesCount || securityCount})</span>)}
      </div>
    </div>
  );
};

const GroupCellRenderer = (props) => {
  if (props.data.securityRow) {
    return <SecurityCell {...props}/>;
  } else {
    return <LevelCell {...props}/>;
  }
};


GroupCellRenderer.prototype = {
  data: PropTypes.object.isRequired, //supplied by ag-grid
};

export default GroupCellRenderer;
